import React from "react";
import { useTranslation } from "react-i18next";
const ConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
   const { t } = useTranslation();
  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      style={{ display: isOpen ? "block" : "none" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content ">
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">{t("button.deleteConfirmationTitle")}</h5>
            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
              onClick={onCancel}
            ></button>
          </div>
          <div className="modal-body">
            <p>{t("button.deleteConfirmationMessage")}</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              onClick={onConfirm}
            >
             {t("button.delete")}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={onCancel}
            >
              {t("button.cancel")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
